// DEPRECATED COMPONENT, DO NOT USE. USE APP-COMPONENTS AppBar INSTEAD.
import React from 'react';
import PropTypes from 'prop-types';
import Hamburger from "../../../Display/Hamburger";
var UUAppBar = function UUAppBar(props) {
  var id = props.id,
    style = props.style,
    iconElementLeft = props.iconElementLeft,
    iconStyleLeft = props.iconStyleLeft,
    iconElementRight = props.iconElementRight,
    iconStyleRight = props.iconStyleRight,
    onHamburgerIconClick = props.onHamburgerIconClick,
    opened = props.opened;
  return /*#__PURE__*/React.createElement("div", {
    className: "flex items-center bg-brand-blue text-white justify-between p-3 relative w-full z-10",
    "data-testid": id,
    id: id,
    style: style
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-auto items-center"
  }, onHamburgerIconClick ? /*#__PURE__*/React.createElement(Hamburger, {
    id: id,
    "data-testid": id,
    className: "mr-8",
    opened: opened,
    onMenuClick: props.onHamburgerIconClick
  }) : null, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-auto",
    style: iconStyleLeft
  }, iconElementLeft)), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-initial",
    style: iconStyleRight
  }, iconElementRight));
};
UUAppBar.propTypes = {
  /** id for reference */
  id: PropTypes.string,
  /** Override the inline-styles of the root element || Not Recommended */
  style: PropTypes.object,
  /** The custom element to be displayed on the left side of the app bar. */
  iconElementLeft: PropTypes.node,
  /** Override the inline-styles of the element displayed on the left side of the app bar. */
  iconStyleLeft: PropTypes.object,
  /** The custom element to be displayed on the right side of the app bar. */
  iconElementRight: PropTypes.node,
  /** Override the inline-styles of the element displayed on the right side of the app bar. */
  iconStyleRight: PropTypes.object,
  /** Function for when the left hamburger icon is selected via a touch tap. */
  onHamburgerIconClick: PropTypes.func,
  /** If true, App Bar will recognize as opened */
  opened: PropTypes.bool.isRequired
};
UUAppBar.defaultProps = {
  id: '',
  style: {},
  iconElementLeft: '',
  iconStyleLeft: {},
  iconElementRight: '',
  iconStyleRight: {},
  onHamburgerIconClick: null
};
export default UUAppBar;